<template>
	<aside class="panel">
		<SideLinksPanel
			:linkedArticles="relatedArticles"
			:articleId="articleId"
			:boxArticlesIds="boxArticlesIds"
			:isAdmin="isEditor"
			v-show="showSideLinks"
			@cardsloaded="checkArticles"
		/>
		<SideSummaryPanel
			v-if="summaryVisible"
			:summaryArticleId="summaryArticleId"
			:isAdmin="isEditor"
		/>
		<SideArticleHistory
			v-if="isEditor && articleId"
			:isFullHeight="fullHeightHistory"
			:articleId="articleId"
			ref="artHistory"
		/>
	</aside>
</template>

<script>
import SideLinksPanel from './SideLinksPanel';
import SideSummaryPanel from './SideSummaryPanel';
import SideArticleHistory from './SideArticleHistory';
import { mapGetters } from 'vuex';

export default {
	name: 'SidePanel',
	components: {
		SideLinksPanel,
		SideSummaryPanel,
		SideArticleHistory,
	},
	props: ['relatedArticles', 'articleId', 'boxArticlesIds', 'isHistorical'],
	data: function () {
		return {
			summaryVisible: false,
			summaryArticleId: '',
			haveCards: false,
		};
	},
	mounted() {
		this.listenForRouteChanges();
	},
	methods: {
		listenForRouteChanges: function () {
			let query = this.$route.query;
			if (query && query.resume) {
				this.summaryVisible = true;
				this.summaryArticleId = query.resume;
			} else {
				this.summaryVisible = false;
				this.summaryArticleId = '';
			}
		},
		getArticleHistory: function () {
			if (this.isEditor && this.articleId) {
				this.$refs.artHistory.getArticleHistoryList();
			}
		},
		checkArticles: function (haveCards) {
			this.haveCards = haveCards;
		},
	},
	computed: {
		...mapGetters(['isEditor']),
		fullHeightHistory: function () {
			let isSummaryVisible = this.summaryVisible,
				haveHowtoService = this.haveCards;

			return !isSummaryVisible && !haveHowtoService;
		},
		showSideLinks: function () {
			let isSummaryVisible = this.summaryVisible,
				areRelatedArticles =
					this.relatedArticles && this.relatedArticles.length > 0,
				haveHowtoService = this.haveCards;

			return !isSummaryVisible && areRelatedArticles && haveHowtoService;
		},
	},
	watch: {
		$route: 'listenForRouteChanges',
	},
};
</script>

<style scoped>
.panel {
	flex: 1 0 auto;
	position: relative;
}
</style>
